<!-- src/components/modal/job-list-modal.vue -->
<script>
import { ref } from "vue";
import { useJobStore } from "@/stores/jobStore";

const currentDate = ref(new Date());

export default {
  setup() {
    const store = useJobStore();

    const Jobtype = ["Full Time", "Part Time", "Contract", "Internship"];
    const Joblevel = ["Team Lead", "Manager", "Senior", "Mid-level", "Junior"];
    const Experience = ["Entry Level", "Mid Level", "Expert"];
    const Qualification = ["Certificate/Diploma", "Bachelor Degree", "Master Degree", "PhD", "Others"];
    const Gender = ["Any", "Male", "Female"];
    const City = ["Nairobi", "Mombasa", "Kisumu", "Eldoret"];
    const State = ["Nairobi County", "Mombasa County", "Kisumu County", "Uasin Gishu"];
    const Country = ["Kenya", "Uganda", "Tanzania", "Rwanda"];

    const startdate = currentDate;
    const dateFormat = "dd-MM-yyyy";

    const submitForm = async () => {
      await store.save();
      // Success modal is still triggered via data-bs-* on the button
    };

    return {
      store,
      Jobtype,
      Joblevel,
      Experience,
      Qualification,
      Gender,
      City,
      State,
      Country,
      startdate,
      dateFormat,
      submitForm,
    };
  },
};
</script>

<template>
  <!-- Add Post -->
  <div class="modal fade" id="add_post">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Post Job</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body pb-0">
            <div class="row">
              <div class="contact-grids-tab pt-0">
                <ul class="nav nav-underline" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="address-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#address"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Location
                    </button>
                  </li>
                </ul>
              </div>

              <div class="tab-content" id="myTabContent">
                <!-- BASIC INFO TAB (ADD) -->
                <div
                  class="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabindex="0"
                >
                  <div class="row">
                    <!-- Job Title -->
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="form-label">
                          Job title <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.title"
                          placeholder="e.g. Senior Laravel Developer"
                        />
                      </div>
                    </div>

                    <!-- Description -->
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="form-label">
                          Job description <span class="text-danger">*</span>
                        </label>
                        <textarea
                          rows="4"
                          class="form-control"
                          v-model="store.form.description"
                          placeholder="Provide a clear summary of responsibilities, required skills and benefits for this role."
                        ></textarea>
                      </div>
                    </div>

                    <!-- Category & Type -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Job category <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.category"
                          placeholder="e.g. Software Engineering, Sales, HR"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Employment type <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Jobtype"
                          id="job-type"
                          placeholder="Select employment type"
                          v-model="store.form.job_type"
                        />
                      </div>
                    </div>

                    <!-- Level & Experience -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Seniority level <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Joblevel"
                          id="job-level"
                          placeholder="Select seniority level"
                          v-model="store.form.job_level"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Experience required <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Experience"
                          id="experience-level"
                          placeholder="Select experience level"
                          v-model="store.form.experience_level"
                        />
                      </div>
                    </div>

                    <!-- Qualification & Gender -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Minimum qualification <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Qualification"
                          id="qualification"
                          placeholder="Select minimum qualification"
                          v-model="store.form.qualification"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Preferred gender
                        </label>
                        <vue-select
                          :options="Gender"
                          id="gender"
                          placeholder="No preference / select"
                          v-model="store.form.gender"
                        />
                      </div>
                    </div>

                    <!-- Salary -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Minimum salary (gross)
                        </label>
                        <input
                          type="number"
                          min="0"
                          class="form-control"
                          v-model="store.form.min_salary"
                          placeholder="e.g. 60000"
                        />
                        <small class="text-muted">
                          Enter the minimum monthly salary for this position.
                        </small>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Maximum salary (gross)
                        </label>
                        <input
                          type="number"
                          min="0"
                          class="form-control"
                          v-model="store.form.max_salary"
                          placeholder="e.g. 120000"
                        />
                        <small class="text-muted">
                          Enter the maximum monthly salary for this position.
                        </small>
                      </div>
                    </div>

                    <!-- Expiry & Skills -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Application closing date <span class="text-danger">*</span>
                        </label>
                        <div class="input-icon-end position-relative">
                          <date-picker
                            v-model="store.form.expire_at"
                            class="form-control datetimepicker"
                            placeholder="Select closing date"
                            :editable="true"
                            :clearable="false"
                            :input-format="dateFormat"
                          />
                          <span class="input-icon-addon">
                            <i class="ti ti-calendar text-gray-7"></i>
                          </span>
                        </div>
                        <small class="text-muted">
                          After this date the job will be considered closed.
                        </small>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Key skills (comma separated)
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.required_skills"
                          placeholder="e.g. Laravel, Vue 3, REST APIs, MySQL"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#success_modal"
                    >
                      Save &amp; Next
                    </button>
                  </div>
                </div>

                <!-- LOCATION TAB (ADD) -->
                <div
                  class="tab-pane fade"
                  id="address"
                  role="tabpanel"
                  aria-labelledby="address-tab"
                  tabindex="0"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="form-label">
                          Office address <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.address"
                          placeholder="e.g. 4th Floor, Westlands Office Park, Waiyaki Way"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          City <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="City"
                          id="city"
                          placeholder="Select city"
                          v-model="store.form.city"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          County / State <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="State"
                          id="state"
                          placeholder="Select county / state"
                          v-model="store.form.state"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Country <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Country"
                          id="country"
                          placeholder="Select country"
                          v-model="store.form.country"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Postal / ZIP code <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.zip_code"
                          placeholder="e.g. 00100"
                        />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="map-grid mb-3">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6509170.989457427!2d-123.80081967108484!3d37.192957227641294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2sin!4v1669181581381!5m2!1sen!2sin"
                          style="border: 0"
                          allowfullscreen=""
                          loading="lazy"
                          referrerpolicy="no-referrer-when-downgrade"
                          class="w-100"
                        ></iframe>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#success_modal"
                    >
                      Post
                    </button>
                  </div>
                </div>
              </div> <!-- /tab-content -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Post Job -->

  <!-- Add Job Success -->
  <div class="modal fade" id="success_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-xm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center p-3">
            <span class="avatar avatar-lg avatar-rounded bg-success mb-3">
              <i class="ti ti-check fs-24"></i>
            </span>
            <h5 class="mb-2">Job posted successfully</h5>
            <p class="text-muted mb-3">
              Your job has been saved. You can manage applicants from the Candidates section.
            </p>
            <div>
              <div class="row g-2">
                <div class="col-12">
                  <router-link to="/recuritment/job-grid" class="btn btn-dark w-100">
                    Back to list
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Job Success -->

  <!-- EDIT POST (same bindings, used when store.openEdit is called) -->
  <div class="modal fade" id="edit_post">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Edit Job</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body pb-0">
            <!-- We reuse EXACTLY the same structure as the add form,
                 but we keep it short here by using the same tab ids.
                 Because all fields are bound to store.form.*, editing works out of the box. -->
            <div class="row">
              <div class="contact-grids-tab pt-0">
                <ul class="nav nav-underline" id="myTabEdit" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="info-tab-edit"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info-edit"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="address-tab-edit"
                      data-bs-toggle="tab"
                      data-bs-target="#address-edit"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Location
                    </button>
                  </li>
                </ul>
              </div>

              <div class="tab-content" id="myTabContentEdit">
                <!-- BASIC INFO (EDIT) -->
                <div
                  class="tab-pane fade show active"
                  id="basic-info-edit"
                  role="tabpanel"
                  aria-labelledby="info-tab-edit"
                  tabindex="0"
                >
                  <!-- copy of basic-info content, same fields -->
                  <!-- For brevity you can copy/paste from the Add tab;
                       it will work because of the same v-model bindings. -->
                  <!-- START COPY FROM BASIC INFO ABOVE -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="form-label">
                          Job title <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.title"
                          placeholder="e.g. Senior Laravel Developer"
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="form-label">
                          Job description <span class="text-danger">*</span>
                        </label>
                        <textarea
                          rows="4"
                          class="form-control"
                          v-model="store.form.description"
                          placeholder="Provide a clear summary of responsibilities, required skills and benefits for this role."
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Job category <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.category"
                          placeholder="e.g. Software Engineering, Sales, HR"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Employment type <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Jobtype"
                          id="job-type-edit"
                          placeholder="Select employment type"
                          v-model="store.form.job_type"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Seniority level <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Joblevel"
                          id="job-level-edit"
                          placeholder="Select seniority level"
                          v-model="store.form.job_level"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Experience required <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Experience"
                          id="experience-level-edit"
                          placeholder="Select experience level"
                          v-model="store.form.experience_level"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Minimum qualification <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Qualification"
                          id="qualification-edit"
                          placeholder="Select minimum qualification"
                          v-model="store.form.qualification"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Preferred gender
                        </label>
                        <vue-select
                          :options="Gender"
                          id="gender-edit"
                          placeholder="No preference / select"
                          v-model="store.form.gender"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Minimum salary (gross)
                        </label>
                        <input
                          type="number"
                          min="0"
                          class="form-control"
                          v-model="store.form.min_salary"
                          placeholder="e.g. 60000"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Maximum salary (gross)
                        </label>
                        <input
                          type="number"
                          min="0"
                          class="form-control"
                          v-model="store.form.max_salary"
                          placeholder="e.g. 120000"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Application closing date <span class="text-danger">*</span>
                        </label>
                        <div class="input-icon-end position-relative">
                          <date-picker
                            v-model="store.form.expire_at"
                            class="form-control datetimepicker"
                            placeholder="Select closing date"
                            :editable="true"
                            :clearable="false"
                            :input-format="dateFormat"
                          />
                          <span class="input-icon-addon">
                            <i class="ti ti-calendar text-gray-7"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Key skills (comma separated)
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.required_skills"
                          placeholder="e.g. Laravel, Vue 3, REST APIs, MySQL"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- END COPY -->
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#success_modal"
                    >
                      Save changes
                    </button>
                  </div>
                </div>

                <!-- LOCATION (EDIT) -->
                <div
                  class="tab-pane fade"
                  id="address-edit"
                  role="tabpanel"
                  aria-labelledby="address-tab-edit"
                  tabindex="0"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="form-label">
                          Office address <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.address"
                          placeholder="e.g. 4th Floor, Westlands Office Park, Waiyaki Way"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          City <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="City"
                          id="city-edit"
                          placeholder="Select city"
                          v-model="store.form.city"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          County / State <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="State"
                          id="state-edit"
                          placeholder="Select county / state"
                          v-model="store.form.state"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Country <span class="text-danger">*</span>
                        </label>
                        <vue-select
                          :options="Country"
                          id="country-edit"
                          placeholder="Select country"
                          v-model="store.form.country"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">
                          Postal / ZIP code <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.form.zip_code"
                          placeholder="e.g. 00100"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#success_modal"
                    >
                      Save changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal (unchanged) -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete all the marked items, this can't be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
            >
              Cancel
            </a>
            <router-link to="/recuritment/job-list" class="btn btn-danger">
              Yes, Delete
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
